import { render, staticRenderFns } from "./OrderDocumentDownloadButton.vue?vue&type=template&id=38e7d72c"
import script from "./OrderDocumentDownloadButton.vue?vue&type=script&lang=js"
export * from "./OrderDocumentDownloadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports